import { render } from "./BranchItemControl.vue?vue&type=template&id=a45704a2"
import script from "./BranchItemControl.vue?vue&type=script&lang=js"
export * from "./BranchItemControl.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Mobile\\mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__